import { type PlayerSdk } from "@api.video/player-sdk"
import { type FC, useId, useLayoutEffect, useState } from "react"

const ApiVideo: FC<{ apiVideoId: string }> = ({ apiVideoId }) => {
	const playerId = useId()
	const [isLoading, setLoading] = useState(true)
	const [error, setError] = useState<string | null>(null)

	useLayoutEffect(() => {
		let playerSdk: PlayerSdk | null = null

		async function initializePlayer() {
			try {
				setLoading(true)
				setError(null)

				const { PlayerSdk } = await import("@api.video/player-sdk")

				playerSdk = new PlayerSdk(`#${CSS.escape(playerId)}`, { id: apiVideoId, hideTitle: true })

				playerSdk.hideControls()
				playerSdk.showControls([
					"play",
					"seekBackward",
					"seekForward",
					"playbackRate",
					"volume",
					"fullscreen",
					"subtitles",
					"pictureInPicture",
					"progressBar",
					"chromecast",
				])

				setLoading(false)
			} catch (err) {
				console.error("Failed to load API Video player:", err)
				setError("Failed to load video player")
				setLoading(false)
			}
		}

		initializePlayer()

		return () => {
			playerSdk?.destroy()
		}
	}, [apiVideoId, playerId])

	if (error) {
		return <div>Error: {error}</div>
	}

	if (isLoading) {
		return <div>Loading video player...</div>
	}

	return <div id={playerId} />
}

export default ApiVideo
